import Tooltip from "@mui/material/Tooltip";
import { useEffect, useRef, useState } from "react";

import "./EllipsisTextTooltip.css";

interface EllipsisTextTooltipProps {
    text: string;
}

export function EllipsisTextTooltip({ text }: EllipsisTextTooltipProps): JSX.Element {
    const textRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const checkOverflow = () => {
        const element = textRef?.current;
        if (element) {
            setIsOverflowing(element.scrollWidth > element.clientWidth);
        }
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [text]);

    return (
        <Tooltip title={isOverflowing ? text : ""} disableHoverListener={!isOverflowing}>
            <div ref={textRef} className="fl-c-ellipsis-text-tooltip">
                {text}
            </div>
        </Tooltip>
    );
}
